(function () {
    "use strict";

    const UNITS = { INCH: "inch", CM: "cm" };
    let selectedSize = "";
    let currentUnit = UNITS.INCH;

    const elements = {
        // 兼容各种标题命名的尺寸容器
        sizeOpts: document.querySelector('[class*="the-size"]') || document.getElementById("sizeOpts"),
        unitSwitch: document.getElementById("unitSwitch"),
        unitSubmit: document.getElementById("unitSubmit"),
        customerData: document.getElementById("customerData"),
        customSizeUnits: document.querySelectorAll("#customerData .unit"),
        customSizeInputs: document.querySelectorAll("#customerData [data-custom-data]"),
    };

    if (!elements.sizeOpts) return;

    function normalizeSize(s) {
        if (!s) return "";
        return s.toString().toLowerCase().replace(/\s+/g, "").replace(/^us0?/, "");
    }

    function updateUI() {
        const normalizedSelected = normalizeSize(selectedSize);
        // 判断是否为定制尺码：只要包含 "customsize" 即可
        const isCustomSize = normalizedSelected.includes("customsize");

        if (elements.customerData) {
            elements.customerData.classList.toggle("hidden", !isCustomSize);
        }

        // 激活/反激活定制属性
        elements.customSizeInputs.forEach((element) => {
            const customData = element.getAttribute('data-custom-data');
            element.name = isCustomSize ? customData : customData.replace('properties', 'disabled_properties');
        });

        // 同步单位显示
        elements.customSizeUnits.forEach((span) => (span.textContent = currentUnit));
        if (elements.unitSubmit) {
            elements.unitSubmit.value = currentUnit === UNITS.INCH ? "Inch" : "CM";
        }
    }

    function toggleUnit() {
        if (!elements.unitSwitch) return;
        currentUnit = elements.unitSwitch.checked ? UNITS.CM : UNITS.INCH;
        updateUI();
    }

    function init() {
        document.addEventListener("change", (event) => {
            const target = event.target;

            if (target.id === "unitSwitch") {
                toggleUnit();
                return;
            }

            // 核心逻辑：如果是尺寸选择器区域的变化，且不在定制表单内部，则更新状态
            if (elements.sizeOpts.contains(target) && !target.closest('#customerData')) {
                selectedSize = target.value;
                updateUI();
            }
        });

        // 初始化状态：从 Radio 或 Select 中获取当前值
        const variantInput = elements.sizeOpts.querySelector('input:checked') || elements.sizeOpts.querySelector('select');
        if (variantInput) {
            selectedSize = variantInput.value;
        }
        updateUI();
    }

    init();
})();
